<div *ngIf="!ticket">Loading</div>
<div *ngIf="ticket">
	<div class="ticket-header">
		<div class="ticket-header__top">
			<div class="ticket-header__meta">
				{{ ticket.ticketMode | titlecase }}
				<span class="ticket-header__ref"># {{ ticket.ticketReference }}</span>
				<nz-divider nzType="vertical"></nz-divider>
				<span class="ticket-header__label">Created</span>
				<span>{{ ticket.createdAt | date: 'dd MMM yyyy HH:mm' }}</span>
			</div>
			<div class="ticket-header__step">
				<span nz-icon nzType="apartment" nzTheme="outline"></span>
				<span>{{ ticket.currentStepAndStateLabel }}</span>
			</div>
		</div>

		<nz-divider></nz-divider>

		<div class="ticket-header__details">

			<!-- Member -->
			<div class="ticket-header__section">
				<span class="ticket-header__section-title">
					<span nz-icon nzType="user" nzTheme="outline"></span> Member
				</span>
				<div class="ticket-header__fields" *ngIf="ticket.member as m">
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Name</span>
						<span>{{ m.name }} {{ m.surname }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">ID Number</span>
						<span>{{ m.idNumber }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Mobile</span>
						<span>{{ m.msisdn || '—' }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Email</span>
						<span>{{ m.emailAddress || '—' }}</span>
					</div>
				</div>
			</div>

			<!-- Dependant -->
			<div class="ticket-header__section" *ngIf="ticket.dependant">
				<span class="ticket-header__section-title">
					<span nz-icon nzType="team" nzTheme="outline"></span> Dependant
				</span>
				<div class="ticket-header__fields">
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Name</span>
						<span>{{ ticket.dependant.name }} {{ ticket.dependant.surname }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Relationship</span>
						<span>{{ ticket.dependant.relationship | titlecase }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">ID Number</span>
						<span>{{ ticket.dependant.idNumber }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Mobile</span>
						<span>{{ ticket.dependant.msisdn || '—' }}</span>
					</div>
				</div>
			</div>

			<!-- Policy -->
			<div class="ticket-header__section" *ngIf="ticket.policy">
				<span class="ticket-header__section-title">
					<span nz-icon nzType="file-protect" nzTheme="outline"></span> Policy
				</span>
				<div class="ticket-header__fields">
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Policy #</span>
						<span>{{ ticket.policy!.policyNumber }}</span>
					</div>
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Product</span>
						<span>{{ ticket.policy!.product?.name || '—' }}</span>
					</div>
					<!-- <div class="ticket-header__field">
						<span class="ticket-header__field-label">Premium</span>
						<span>{{ ticket.policy!.premiumAmount | currency: 'ZAR' : 'symbol-narrow' }}</span>
					</div> -->
					<div class="ticket-header__field">
						<span class="ticket-header__field-label">Status</span>
						<nz-tag [nzColor]="policyStatusColor(ticket.policy!.status!)">
							{{ ticket.policy!.status | titlecase }}
						</nz-tag>
					</div>
				</div>
			</div>

		</div>
	</div>

	<nz-divider></nz-divider>
	<app-ticket-history [ticket]="ticket"></app-ticket-history>
</div>
